import { io } from 'socket.io-client';
import { getUserId } from './utils/identity';

// Use environment variable or default to localhost:3001
// When running in development on the same machine but different browsers,
// we need to ensure we're hitting the right host.
const URL = import.meta.env.VITE_API_URL || (import.meta.env.MODE === 'production'  
  ? undefined 
  : window.location.hostname === 'localhost' 
    ? 'http://localhost:3001' 
    : `http://${window.location.hostname}:3001`);

export const socket = io(URL, {
    autoConnect: false,
    auth: (cb) => {
        // Dynamic auth callback ensures userId is always fresh
        cb({ userId: getUserId() });
    },
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 20000,
});
